import { IDict } from "./types";

export const hi: IDict = {
  Jobs: "नौकरियां",
  "No Jobs": "कोई नौकरियां नहीं",
  Billing: "बिलिंग",
  Credits: "क्रेडिट्स",
  "Pay Per Use": "प्रति उपयोग भुगतान",
  "Feature Voting": "फ़ीचर वोटिंग",
  "Free Karaoke Left": "मुफ़्त कराओके शेष",
  "Upgrade Now to Create More": "अधिक बनाने के लिए अभी अपग्रेड करें",
  "Storage is Full": "स्टोरेज भर गया है",
  "Youka is running out of storage space":
    "Youka के पास स्टोरेज स्पेस खत्म हो रहा है",
  "Please free up at least 1 GB before creating new karaoke":
    "नया कराओके बनाने से पहले कृपया कम से कम 1 GB जगह खाली करें",
  "Click the button to check again": "फिर से जांचने के लिए बटन पर क्लिक करें",
  "No Internet Connection": "कोई इंटरनेट कनेक्शन नहीं",
  "Youka cannot connect to the internet":
    "Youka इंटरनेट से कनेक्ट नहीं हो सकता",
  "Please make sure you have internet connection":
    "कृपया सुनिश्चित करें कि आपके पास इंटरनेट कनेक्शन है",
  "Update is ready": "अपडेट तैयार है",
  "Click the button to update": "अपडेट करने के लिए बटन पर क्लिक करें",
  "Library Folder": "लाइब्रेरी फ़ोल्डर",
  "Export Folder": "निर्यात फ़ोल्डर",
  "Sync Model": "सिंक मॉडल",
  "Max Video Quality": "अधिकतम वीडियो गुणवत्ता",
  "Speed / Compression Preset": "गति / संपीड़न प्रीसेट",
  Change: "परिवर्तन",
  "dialogs.upgrade.upgrade_to_pro":
    "जिस फीचर की आप तलाश कर रहे हैं वह प्रो प्लान का हिस्सा है, इस फीचर को अनलॉक करने के लिए अभी अपग्रेड करें।",
  "dialogs.upgrade.upgrade_to_standard":
    "जिस फीचर की आप तलाश कर रहे हैं वह स्टैंडर्ड प्लान का हिस्सा है, इस फीचर को अनलॉक करने के लिए अभी अपग्रेड करें।",
  heads_up: "ध्यान दें!",
  "dialogs.edit_lyrics.not_supported":
    "आपकी चुनी हुई भाषा वर्तमान में स्वचालित लिरिक्स सिंक्रोनाइज़ेशन के लिए समर्थित नहीं है। हालाँकि, आप अपनी प्रगति को सहेज सकते हैं और फिर लिरिक्स को मैन्युअली सिंक्रोनाइज़ करने के लिए लाइन लेवल एडिटर का उपयोग कर सकते हैं।",
  "dialogs.create.title": "नया कराओके बनाएं",
  "dialogs.create.description":
    "नया कराओके बनाने के लिए कृपया नीचे दिए गए फॉर्म को भरें, आप ऑडियो या वीडियो फ़ाइल का उपयोग कर सकते हैं, लिरिक्स वैकल्पिक हैं।",
  "dialogs.edit_lyrics.description":
    "सहेजने के बाद, सिंक प्रक्रिया शुरू हो जाएगी, आप प्रगति को जॉब्स टैब में देख सकते हैं",
  "dialogs.upgrade.see_plans": "प्लान देखें",
  "dialogs.upgrade.unlock": "अनलॉक करें",
  "comps.sync_editor.attach_previous": "पिछले शब्द से संलग्न करें",
  "comps.sync_editor.attach_next": "अगले शब्द से संलग्न करें",
  "comps.plans.title":
    "वह प्लान चुनें जो आपकी ज़रूरतों के लिए सबसे अच्छा हो। आप हमेशा अपग्रेड या डाउनग्रेड कर सकते हैं",
  "Font Size": "फ़ॉन्ट आकार",
  Spacing: "अंतराल",
  Outline: "आउटलाइन",
  "Margin Bottom": "निचला मार्जिन",
  "Max Chars per Line": "प्रति पंक्ति अधिकतम अक्षर",
  Bold: "बोल्ड",
  Italic: "इटैलिक",
  Shadow: "छाया",
  month: "महीना",
  songs: "गाने",
  Title: "शीर्षक",
  "Save and Sync": "सहेजें और सिंक करें",
  Lyrics: "लिरिक्स",
  Update: "अपडेट",
  Playlist: "प्लेलिस्ट",
  Canceling: "रद्द कर रहा है",
  Play: "चलाएं",
  "Lyrics Language": "लिरिक्स की भाषा",
  "Background Image": "पृष्ठभूमि चित्र",
  "Basic Version": "बेसिक वर्शन",
  "Standard Version": "स्टैंडर्ड वर्शन",
  "Pro Version": "प्रो वर्शन",
  "Trial Version": "ट्रायल वर्शन",
  "No Active Plan": "कोई सक्रिय प्लान नहीं",
  "Days Left in Trial": "ट्रायल में बचे दिन",
  Paste: "पेस्ट करें",
  "Sync Lyrics": "लिरिक्स सिंक करें",
  Show: "दिखाएं",
  Settings: "सेटिंग्स",
  Retry: "पुनः प्रयास करें",
  "Create Karaoke": "कराओके बनाएं",
  Canceled: "रद्द किया गया",
  Reset: "रीसेट करें",
  "Edit Video": "वीडियो संपादित करें",
  Download: "डाउनलोड करें",
  "Edit Metadata": "मेटाडेटा संपादित करें",
  "Subtitle Designer": "सबटाइटल डिज़ाइनर",
  Export: "निर्यात करें",
  year: "वर्ष",
  Basic: "बेसिक",
  Standard: "स्टैंडर्ड",
  Pro: "प्रो",
  Accept: "स्वीकार करें",
  "Add new word": "नया शब्द जोड़ें",
  "Add to queue": "कतार में जोड़ें",
  "An unknown error occurred": "एक अज्ञात त्रुटि हुई",
  Annually: "वार्षिक",
  "Are you sure you want to delete this karaoke song?":
    "क्या आप वाकई इस कराओके गीत को हटाना चाहते हैं?",
  "Artist Name": "कलाकार का नाम",
  "Audio or Video File": "ऑडियो या वीडियो फ़ाइल",
  Audio: "ऑडियो",
  "Auto Karaoke Generator": "ऑटो कराओके जनरेटर",
  "Auto Lyrics Sync": "ऑटो लिरिक्स सिंक",
  "Cancel Plan": "प्लान रद्द करें",
  Cancel: "रद्द करें",
  Close: "बंद करें",
  "Create Karaoke from song": "गीत से कराओके बनाएं",
  "Create Karaoke from local files": "स्थानीय फाइलों से कराओके बनाएं",
  "Create new karaoke": "नया कराओके बनाएं",
  Create: "बनाएं",
  "Current Plan": "वर्तमान प्लान",
  "Dark Mode": "डार्क मोड",
  Decline: "अस्वीकार करें",
  "Delete word": "शब्द हटाएं",
  Delete: "हटाएं",
  "Edit Lyrics": "लिरिक्स संपादित करें",
  Edit: "संपादित करें",
  "Export to mp3/mp4": "mp3/mp4 में निर्यात करें",
  "Go Back to EULA": "EULA पर वापस जाएं",
  "Go back": "वापस जाएं",
  "Go forward": "आगे बढ़ें",
  Home: "होम",
  "I accept the terms and commit to avoiding unlicensed use of copyrighted content":
    "मैं शर्तों को स्वीकार करता हूं और कॉपीराइट सामग्री के बिना लाइसेंस उपयोग से बचने के लिए प्रतिबद्ध हूं",
  Instruments: "साज़",
  Key: "की",
  Library: "लाइब्रेरी",
  "Light Mode": "लाइट मोड",
  "Line Level Sync": "लाइन लेवल सिंक",
  "Line Level": "लाइन लेवल",
  "Lyrics (optional)": "लिरिक्स (वैकल्पिक)",
  "Lyrics Sync Editor": "लिरिक्स सिंक संपादक",
  Manage: "प्रबंधन करें",
  Monthly: "मासिक",
  "Most popular": "सबसे लोकप्रिय",
  "No new notifications": "कोई नई सूचनाएं नहीं",
  "No results": "कोई परिणाम नहीं",
  "No songs in library": "लाइब्रेरी में कोई गाने नहीं",
  "No songs in queue": "कतार में कोई गाने नहीं",
  Notifications: "सूचनाएं",
  Off: "बंद",
  Or: "या",
  "Plan canceled, will end in": "प्लान रद्द किया गया है, समाप्त होगा",
  "Play word in loop": "शब्द को लूप में चलाएं",
  "Preparing Youka": "Youka तैयार कर रहा है",
  "Process 2 karaokes at a time": "एक समय में 2 कराओके प्रोसेस करें",
  "Process 5 karaokes at a time": "एक समय में 5 कराओके प्रोसेस करें",
  Queue: "कतार",
  Ready: "तैयार",
  "Remove from queue": "कतार से निकालें",
  "Resume plan": "प्लान फिर से शुरू करें",
  "Save and Resync": "सहेजें और पुनः सिंक करें",
  Save: "सहेजें",
  "Saving...": "सहेजा जा रहा है...",
  Search: "खोजें",
  "Select plan": "प्लान चुनें",
  "Sign In": "साइन इन करें",
  "Sign Out": "साइन आउट करें",
  "Sign Up": "साइन अप करें",
  "Song Name": "गाने का नाम",
  "Start typing to search or paste YouTube URL":
    "खोजने के लिए टाइप करना प्रारंभ करें या YouTube URL पेस्ट करें",
  "Start typing to search": "खोजने के लिए टाइप करना प्रारंभ करें",
  "Subtitle Track": "सबटाइटल ट्रैक",
  Subtitles: "सबटाइटल्स",
  Tempo: "टेम्पो",
  "Terms and Conditions": "नियम और शर्तें",
  "This action cannot be undone.": "इस क्रिया को पूर्ववत नहीं किया जा सकता है।",
  "Thumbnail URL": "थंबनेल URL",
  "To keep the karaoke fun going, please upgrade":
    "कराओके का मजा बनाए रखने के लिए कृपया अपग्रेड करें",
  "Unlock Premium Features with an Upgrade!":
    "अपग्रेड के साथ प्रीमियम फीचर्स अनलॉक करें!",
  "Update Payment Method": "भुगतान विधि अपडेट करें",
  "Upgrade to Pro plan to enable":
    "सक्षम करने के लिए प्रो प्लान में अपग्रेड करें",
  Upgrade: "अपग्रेड करें",
  Version: "संस्करण",
  Video: "वीडियो",
  Vocals: "वोकल्स",
  "Waiting in queue": "कतार में प्रतीक्षा",
  "Word Level Sync": "शब्द स्तर सिंक",
  "Word Level": "शब्द स्तर",
  "You need to accept the EULA to use Youka":
    "Youka का उपयोग करने के लिए आपको EULA को स्वीकार करना होगा",
  "Your lyrics have been saved successfully. A resync is currently in progress. You can monitor the progress in the notification area. Once the resync is complete, you'll be able to see the changes - just hit 'play'.":
    "आपके लिरिक्स सफलतापूर्वक सहेजे गए हैं। वर्तमान में पुनः सिंक हो रहा है। आप प्रगति को अधिसूचना क्षेत्र में देख सकते हैं। पुनः सिंक पूरा होने के बाद, आप परिवर्तनों को देख पाएंगे - बस 'प्ले' दबाएं।",
  "Your trial version of Youka has expired":
    "आपकी Youka का ट्रायल संस्करण समाप्त हो गया है",
  "dialogs.youtube.title":
    "ऑनलाइन वीडियो देखने और डाउनलोड करने के लिए yt-dlp प्लगइन स्थापित करें",
  "dialogs.youtube.description":
    "प्लगइन सक्षम करने से पहले कृपया निम्नलिखित चेतावनियों को पढ़ें और स्वीकार करें।",
  "dialogs.youtube.agree":
    "मैंने उपरोक्त चेतावनियों को पढ़ लिया है और समझ लिया है",
  "dialogs.youtube.install": "प्लगइन स्थापित करें",
  "dialogs.youtube.install_success": "प्लगइन सफलतापूर्वक स्थापित हो गया",
  "dialogs.youtube.install_success_description":
    "अब आप ऑनलाइन वीडियो खोज सकते हैं और देख सकते हैं",
  "dialogs.youtube.install_error": "प्लगइन स्थापना विफल हो गई",
  "alert.youtube.description":
    "ऑनलाइन वीडियो खोज और डाउनलोड प्लगइन (yt-dlp) पहले से स्थापित नहीं है। स्थापित करने के लिए, कृपया 'स्थापित करें' बटन पर क्लिक करें।",
  "alert.youtube.install": "प्लगइन स्थापित करें",
  "dialogs.settings.enable_youtube": "yt-dlp प्लगइन सक्षम करें",
  "dialogs.youtube.warnings": [
    {
      title: "कानूनी अनुपालन",
      description:
        "सुनिश्चित करें कि इस प्लगइन का आपका उपयोग सभी लागू कानूनों और उन प्लेटफार्मों की सेवा की शर्तों के पूर्ण अनुपालन में है, जिनके साथ आप इंटरैक्ट करते हैं, जैसे कि YouTube।",
    },
    {
      title: "कॉपीराइट और लाइसेंसिंग",
      description:
        "यह प्लगइन ऐसे कार्यों की अनुमति दे सकता है (जैसे सामग्री डाउनलोड करना) जो उचित उपयोग न किए जाने पर कॉपीराइट कानूनों का उल्लंघन कर सकते हैं या लाइसेंसिंग समझौतों का उल्लंघन कर सकते हैं। सामग्री निर्माताओं के अधिकारों का सम्मान करना और केवल कानूनी रूप से अनुमत उद्देश्यों के लिए प्लगइन का उपयोग करना महत्वपूर्ण है।",
    },
    {
      title: "कोई समर्थन नहीं",
      description:
        "इस प्लगइन को सक्षम करना हमारे कंपनी द्वारा समर्थन या समर्थन का संकेत नहीं देता है। प्लगइन एक अलग इकाई है और इसके संचालन या इसके उपयोग के परिणामों के लिए हम जिम्मेदार नहीं हैं।",
    },
    {
      title: "उपयोगकर्ता की जिम्मेदारी",
      description:
        "इस प्लगइन का उपयोग करके आप द्वारा किए गए किसी भी कार्य के लिए आप पूरी तरह से जिम्मेदार हैं। इसमें किसी भी गलत उपयोग या सेवा की शर्तों का उल्लंघन के परिणामस्वरूप उत्पन्न होने वाले किसी भी कानूनी परिणाम शामिल हैं।",
    },
    {
      title: "संभावित जोखिम",
      description:
        "प्लगइन का गलत उपयोग प्लेटफार्मों या प्रभावित पार्टियों द्वारा खाता निलंबन या कानूनी कार्रवाई का कारण बन सकता है।",
    },
    {
      title: "सूचित सहमति",
      description:
        "इस प्लगइन को सक्षम करने के लिए आगे बढ़ने से, आप स्वीकार करते हैं कि आपने इन चेतावनियों को पढ़ लिया है और समझ लिया है और प्लगइन के उपयोग के लिए पूरी जिम्मेदारी स्वीकार करते हैं।",
    },
  ],
  "model.auto": "स्वतः सर्वश्रेष्ठ मॉडल का चयन करें।",
  "model.audioshake.transcription":
    "पहला सर्वश्रेष्ठ मॉडल, जो ट्रांसक्रिप्शन और फिर संरेखण में शामिल होता है, उत्कृष्ट परिणाम देता है लेकिन यह पे पर यूज और ट्रायल उपयोगकर्ताओं के लिए विशेष रूप से सुलभ है (10 मिनट तक लग सकते हैं)।",
  "model.audioshake":
    "दूसरा सर्वश्रेष्ठ मॉडल, आपूर्ति किए गए लिरिक्स के साथ संरेखित होता है, जहां असंगतताएं उप-परिणाम दे सकती हैं (10 मिनट तक लग सकते हैं)।",
  "model.wav2vec2":
    "तीसरा सर्वश्रेष्ठ मॉडल, आपूर्ति किए गए लिरिक्स के साथ संरेखित होता है, जहां असंगतताएं उप-परिणाम दे सकती हैं, लगभग सभी भाषाओं का समर्थन करता है। (30 सेकंड तक लग सकते हैं)",
  "model.whisper":
    "चौथा सर्वश्रेष्ठ मॉडल, जो ट्रांसक्रिप्शन और फिर संरेखण में शामिल होता है। आउटपुट लिरिक्स सटीक नहीं हो सकते हैं, हालांकि सिंक्रनाइज़ेशन स्वीकार्य है (2 मिनट तक लग सकते हैं)।",
  "sync.line.instructions": [
    "गीत चलाने और सिंक्रनाइज़ेशन प्रक्रिया शुरू करने के लिए प्ले बटन पर क्लिक करें",
    "जब आप वर्तमान पंक्ति का पहला शब्द सुनें तो सेट स्टार्ट बटन पर क्लिक करें",
    "वर्तमान पंक्ति का अंतिम शब्द सुनने के बाद सेट एंड बटन पर क्लिक करें",
    "सभी पंक्तियों को सिंक्रनाइज़ करने तक जारी रखें",
  ],
  Undo: "पूर्ववत करें",
  Redo: "पुनः करें",
  "Set Start": "शुरू सेट करें",
  "Set End": "अंत सेट करें",
  "dialogs.edit_lyrics.transcription":
    "ट्रांसक्रिप्शन मॉडल का उपयोग करते समय, मॉडल स्वतंत्र रूप से गीत को ट्रांसक्राइब करता है और अपने दम पर लिरिक्स की पहचान करता है, किसी भी प्रदान किए गए लिरिक्स पर निर्भर किए बिना। बाद में, आपके पास सिंक टूल का उपयोग करके लिरिक्स को समायोजित करने का विकल्प होता है।",
  "Duet Editor": "डुएट संपादक",
  "Manual Line Sync": "मैन्युअल लाइन सिंक",
  "New Style": "नई शैली",
  Style: "शैली",
  Singer: "गायक",
  "Style Editor": "शैली संपादक",
  Word: "शब्द",
  Line: "लाइन",
  "Split Line": "लाइन विभाजित करें",
  "Upgrade to Enable": "सक्षम करने के लिए अपग्रेड करें",
  upgrade_description:
    "आपके द्वारा पहले से उत्पन्न किए गए कराओके ट्रैक को सुनने या डाउनलोड करने का विकल्प है। हालाँकि, यदि आप अतिरिक्त कराओके ट्रैक बनाना चाहते हैं, तो अपग्रेड आवश्यक है।",
  "dialogs.global.no_user.title": "कोई सक्रिय प्लान नहीं",
  "dialogs.global.no_user.description":
    "जारी रखने के लिए कृपया प्लान अपग्रेड करें",
  "dialogs.global.no_role.title": "कोई सक्रिय प्लान नहीं",
  "dialogs.global.no_role.description":
    "जारी रखने के लिए कृपया प्लान अपग्रेड करें",
  "dialogs.global.blocked_ip.title": "आपका आईपी अवरुद्ध है",
  "dialogs.global.blocked_ip.description": "कृपया समर्थन से संपर्क करें",
  "dialogs.global.rate_limit.title": "दर सीमा अधिक हो गई",
  "dialogs.global.rate_limit.description":
    "असीमित पहुँच के लिए आप पे पर यूज प्लान में स्विच कर सकते हैं।",
  "dialogs.global.disk_full.title": "स्टोरेज भर गया है",
  "dialogs.global.disk_full.description":
    "कृपया Youka का उपयोग जारी रखने के लिए कुछ जगह खाली करें",
  "dialogs.global.too_big.title": "ऑडियो फ़ाइल आकार सीमा से अधिक है",
  "dialogs.global.too_big.description":
    "कृपया ध्यान दें कि ऑडियो फ़ाइल की अधिकतम अवधि 15 मिनट से अधिक नहीं हो सकती है।",
  Help: "सहायता",
  Original: "मूल",
  Sort: "क्रमबद्ध करें",
  "sort.date.asc": "निर्माण तिथि (सबसे पुरानी से नवीनतम)",
  "sort.date.desc": "निर्माण तिथि (नवीनतम से सबसे पुरानी)",
  "sort.title.asc": "शीर्षक (A से Z)",
  "sort.title.desc": "शीर्षक (Z से A)",
  "dialogs.trim.title": "ट्रिम",
  "dialogs.trim.description":
    "गीत का वह भाग चुनने के लिए वेवफॉर्म पर समायोज्य सीमा का उपयोग करें जिसे आप रखना चाहते हैं।",
  Start: "प्रारंभ",
  End: "अंत",
  Time: "समय",
  Related: "संबंधित",
  preserve_vocals: "वोकल्स संरक्षित करें",
  preserve_vocals_description:
    "इसका उपयोग सहायक वोकल्स जैसे वोकल्स को संरक्षित करने के लिए करें।",
  "Separate Audio": "ऑडियो अलग करें",
  "Separate Model": "मॉडल अलग करें",
  "Add Lyrics": "लिरिक्स जोड़ें",
  "Background Image or Video": "पृष्ठभूमि छवि या वीडियो",
  Docs: "डॉक्स",
  Watch: "देखें",
  Hide: "छिपाएं",
  "watch.sync.title": "लिरिक्स सिंक को आसानी से कैसे ठीक करें?",
  "watch.sync.url": "https://www.youtube.com/watch?v=kEHzfAwQBzo",
  Review: "समीक्षा",
  "watch.review.title": "ट्रस्टपायलट पर Youka की समीक्षा करें",
  "Import Subtitles": "सबटाइटल आयात करें",
  Import: "आयात करें",
  "How to use": "कैसे उपयोग करें",
  Uppercase: "अंग्रेजी बड़े अक्षरों में बदलें",
  "Open Dual Screen": "डुअल स्क्रीन खोलें",
  "Close Dual Screen": "डुअल स्क्रीन बंद करें",
  "Import Karaoke File": "काराॅके फ़ाइल आयात करें",
  "dialogs.import_karaoke.title": "फ़ाइल से कराओके आयात करें",
  "dialogs.import_karaoke.description":
    "एक वीडियो या ऑडियो फ़ाइल और एक LRC फ़ाइल आयात करें जो काराॅके बनाने के लिए आवश्यक है।",
  optional: "वैकल्पिक",
  "Trial Expired": "प्रयोग समाप्त",
  "Subtitles Settings": "सबटाइटल सेटिंग्स",
  Milliseconds: "मिलिसेकंड",
  Seconds: "सेकंड",
  Text: "टेक्स्ट",
  Enabled: "सक्षम",
  Duration: "अवधि",
  Gap: "अंतराल",
  Offset: "ऑफसेट",
  "Min Duration": "न्यूनतम अवधि",
  "Max Duration": "अधिकतम अवधि",
  "Fade In": "फेड इन",
  "Fade Out": "फेड आउट",
  "plugins.title.title": "गीत का शीर्षक",
  "plugins.title.description": "गीत का शीर्षक वीडियो के शुरुआत में दिखाएं",
  "plugins.gap_text.title": "अंतराल टेक्स्ट",
  "plugins.gap_text.description": "अंतराल में टेक्स्ट दिखाएं",
  "plugins.gap_progress_bar.title": "अंतराल प्रग्रेस बार",
  "plugins.gap_progress_bar.description": "अंतराल में प्रग्रेस बार दिखाएं",
  "plugins.fade.title": "फेड इन और फेड आउट",
  "plugins.fade.description": "फेड इन और फेड आउट दिखाएं",
  "plugins.offset.title": "ऑफसेट",
  "plugins.offset.description": "सबटाइटल को ऑफसेट करें",
  "plugins.countdown.title": "गिनती वापस",
  "plugins.countdown.description": "अंतराल में गिनती वापस दिखाएं",
  Auto: "स्वतः",
  Subword: "उपशब्द",
  Countdown: "गिनती वापस",
  "Restart required": "पुनः सुनिश्चित करें",
  "Reindex Library": "लाइब्रेरी को फिर से इंडेक्स करें",
  "Create playlist": "प्लेलिस्ट बनाएं",
  "Are you sure you want to delete?": "क्या आप वाकई हटाना चाहते हैं?",
  "Add to playlist": "प्लेलिस्ट में जोड़ें",
  "New playlist": "नई प्लेलिस्ट",
  "Remove from this playlist": "इस प्लेलिस्ट से हटाएं",
  Songs: "गीत",
  Playlists: "प्लेलिस्ट",
  Name: "नाम",
  Photo: "फोटो",
  "No playlists": "कोई प्लेलिस्ट नहीं",
  "Welcome to Youka": "Youka में आपका स्वागत है",
  "Search songs online": "ऑनलाइन गीत खोजें",
  "create.file.title": "फ़ाइल से कराओके बनाएं",
  "create.file.description":
    "MP3, MP4 या अन्य फ़ाइलें अपलोड करें और तुरंत सिंक्रनाइज़्ड लिरिक्स के साथ कराओके वीडियो बनाएं।",
  "create.online.title": "ऑनलाइन गानों से कराओके बनाएं",
  "create.online.description":
    "ऑनलाइन गाने खोजें या गाने का URL पेस्ट करें और तुरंत सिंक्रनाइज़्ड लिरिक्स के साथ कराओके वीडियो बनाएं।",
  "Change Background": "पृष्ठभूमि बदलें",
  "Duet Line Split": "डुएट लाइन विभाजित करें",
  Both: "दोनों",
  Custom: "विशेष",
  Edited: "संपादित",
  Trimmed: "कटौती",
  Instrumental: "इंस्ट्रुमेंटल",
  "Add Subword": "उपशब्द जोड़ें",
  "plugins.max_chars.title": "प्रति पंक्ति अधिकतम अक्षर",
  "plugins.max_chars.description": "प्रति पंक्ति अक्षरों की संख्या सीमित करें",
  Limit: "सीमा",
  "Background Box": "पृष्ठभूमि बॉक्स",
  Height: "ऊंचाई",
  Width: "चौड़ाई",
  Alpha: "अल्फा",
  Color: "रंग",
  Duplicate: "डुप्लिकेट",
  "Convert to 16x9": "16x9 में बदलें",
  "Resize Video": "वीडियो का आकार बदलें",
  "Line Alignment": "लाइन संरेखण",
  "Shadow Color": "छाया रंग",
  "Outline Color": "आउटलाइन रंग",
  "Active Color": "सक्रिय रंग",
  "Secondary Color": "द्वितीय रंग",
  "Primary Color": "प्राथमिक रंग",
  "Auto Alignment": "स्वतः संरेखण",
  "Auto Color": "स्वतः रंग ",
  "Singer 1": "कंटेंट 1",
  "Singer 2": "कंटेंट 2",
  "Top Row": "शीर्ष पंक्ति",
  "Bottom Row": "निचली पंक्ति",
  "Border Style": "बॉर्डर स्टाइल",
  "Font Name": "फ़ॉन्ट नाम",
  "Experimental Subtitles Display": "प्रयोगात्मक सबटाइटल डिस्प्ले",
  Position: "स्थान",
  "Timing Indicator": "समय संकेतक",
  General: "सामान्य",
  Styles: "शैलियाँ",
  Thumbnail: "थंबनेल",
  "create.url.title": "कराओके बनाएं ऑनलाइन",
  "create.url.description": "yt-dlp समर्थित URL से कराओके बनाएं",
  "Paste a URL or start typing to search":
    "एक URL स्पैस करें या खोजने के लिए टाइप करने शुरू करें",
  Top: "शीर्ष",
  Bottom: "निचला",
  Center: "केंद्र",
  "Auto Line Break": "लाइन स्वतः विभाजित करें",
  "Fill Color": "भरवाने का रंग",
  "Active Line Color": "सक्रिय लाइन रंग",
  "Waiting Line Color": "प्रतीक्षा का रंग",
  "Set as Default": "डिफ़ॉल्ट रखें",
  Default: "डिफ़ॉल्ट",
  "Make Default": "डिफ़ॉल्ट रखें",
  Image: "छवि",
  Pause: "रुकें",
  File: "फ़ाइल",
  "Debug Info": "डीबग जानकारी",
  "File Type": "फ़ाइल प्रकार",
  Language: "भाषा",
  "Reset Settings": "सेटिंग्स रीसेट करें",
  "Failed to start Youka": "Youka शुरू नहीं हो पाया",
  Legacy: "पुरानी",
  Transcription: "प्रतिलिपि",
  Alignment: "संरेखण",
  Imported: "आयातित",
  "With Backing Vocals": "वोकल्स के साथ",
  Stem: "स्टेम",
  Clear: "साफ़ करें",
  "Open Directory": "डायरेक्टरी खोलें",
  "Advanced Settings": "उन्नत सेटिंग्स",
  "How to Add a Background Black Box to Subtitles":
    "उपशीर्षकों में एक काली पृष्ठभूमि बॉक्स कैसे जोड़ें",
  "How to Adjust the Line Length": "लाइन की लंबाई को कैसे समायोजित करें",
  "How to Cancel Your Subscription": "अपनी सदस्यता कैसे रद्द करें",
  "How to Center Subtitles": "उपशीर्षकों को केंद्रित कैसे करें",
  "How to Delete a Karaoke": "एक कराओके को कैसे हटाएं",
  "How to Edit the lyrics": "गीतों को कैसे संपादित करें",
  "How to Fix the Sync": "सिंक को कैसे ठीक करें",
  "How to Keep Choirs": "कोयर को कैसे बनाए रखें",
  "How to Keep the Original Singer’s Voice":
    "मूल गायक की आवाज़ को कैसे बनाए रखें",
  "How to Set Up a Duet": "डुएट कैसे सेट करें",
  "How to Speed Up the Download Process": "डाउनलोड प्रक्रिया को कैसे तेज करें",
  "How to Transfer Your Karaoke Library to a New Computer":
    "अपनी कराओके लाइब्रेरी को नए कंप्यूटर में कैसे ट्रांसफर करें",
  "How to Trim a Karaoke Video": "एक कराओके वीडियो को कैसे काटें",
  FAQ: "अक्सर पूछे जाने वाले प्रश्न",
  "library.description":
    "आपने बनाए गए सभी कराओके ट्रैकों को एक्सेस और प्रबंधित करें। अपने प्रोजेक्ट्स को संपादित करें, व्यवस्थित करें और सुधारें।",
  "How to Change the Background Video":
    "उपशीर्षकों में एक काली पृष्ठभूमि बॉक्स कैसे जोड़ें",
  "Auto Size": "स्वतः आकार",
  "dialogs.global.no_credits.title": "कोई क्रेडिट उपलब्ध नहीं",
  "dialogs.global.no_credits.description":
    "कृपया जारी रखने के लिए क्रेडिट टॉप अप करें",
  "Credits are over! Click to buy more":
    "क्रेडिट खत्म हो गए हैं! अधिक खरीदने के लिए क्लिक करें",
  "How to Add a Line Break": "लाइन विभाजन कैसे जोड़ें",
  "dialogs.global.no_user.many_emails_description":
    "विभिन्न ईमेल पतों का उपयोग करके कई साइन-इन के कारण पहुंच अवरुद्ध कर दी गई है। कृपया जारी रखने के लिए एक सदस्यता खरीदें।",
  "dialogs.global.no_user.virtual_machine_description":
    "आप वर्चुअल मशीन का उपयोग कर रहे हैं, इसलिए पहुंच अवरुद्ध कर दी गई है। मुफ्त ट्रायल एक्सेस के लिए कृपया Youka को एक मानक ऑपरेटिंग सिस्टम पर इंस्टॉल करें। यदि आपके पास सदस्यता है, तो कृपया इसे नवीनीकृत करें ताकि आप दोबारा एक्सेस प्राप्त कर सकें। यदि आपको लगातार कराओके बनाने की आवश्यकता नहीं है, तो आप प्रति उपयोग भुगतान योजना चुन सकते हैं, जिससे आप केवल तभी शुल्क का भुगतान करेंगे जब आप नया कराओके कंटेंट बनाते हैं।",
  "Import Stem": "आयात स्टेम",
  "Active Outline Color": "सक्रिय आउटलाइन रंग",
  "Inactive Outline Color": "असक्रिय आउटलाइन रंग",
  "Inactive Line Color": "असक्रिय लाइन रंग",
  "Active Line": "सक्रिय लाइन",
  "Inactive Line": "असक्रिय लाइन",
  "End Extra": "अंत अतिरिक्त",
  Expand: "विस्तारित",
  Collapse: "संकोचित",
  "Copy Line": "पंक्ति कॉपी करें",
  "Copy Word": "शब्द कॉपी करें",
  "Cut Line": "पंक्ति काटें",
  "Cut Word": "शब्द काटें",
  "Delete Line": "पंक्ति हटाएं",
  "Delete Subword": "उपशब्द हटाएं",
  "Delete Word": "शब्द हटाएं",
  "Add Line": "पंक्ति जोड़ें",
  "Add Word": "शब्द जोड़ें",
  // "Add Subword": "उपशब्द जोड़ें",
  "Paste Line": "पंक्ति चिपकाएं",
  "Paste Word": "शब्द चिपकाएं",
  "Paste Subword": "उपशब्द चिपकाएं",
  "Play Line": "पंक्ति चलाएं",
  "Play Word": "शब्द चलाएं",
  "Select Line": "पंक्ति चुनें",
  "Manual Sync": "मैनुअल सिंक",
  "Trim Start": "शुरू को काटें",
  "Trim End": "अंत को काटें",
  "Creating will use 1 credit": "निर्माण में 1 क्रेडिट लगेगा",
  All: "सभी",
  "Number of Singers": "संगीतकारों की संख्या",
  "Style Mapping": "स्टाइल मैपिंग",
  "Associate subtitle styles with singers":
    "सबटाइटल शैलियों को गायकों से जोड़ें",
  "Upper first line": "ऊपरी पहली पंक्ति",
  "Upper second line": "ऊपरी दूसरी पंक्ति",
  "Lower first line": "निचली पहली पंक्ति",
  "Lower second line": "निचली दूसरी पंक्ति",
  Lock: "लॉक",
  "2 Lines": "2 पंक्तियाँ",
  "4 Lines": "4 पंक्तियाँ",
  Static: "स्थिर",
  Dynamic: "गतिशील",
  "Subtitles Type": "उपशीर्षक प्रकार",
  "Danger Zone": "खतरनाक क्षेत्र",
  Copy: "कॉपी",
  Copied: "कॉपी किया",
  "Copy Settings": "सेटिंग्स कॉपी करें",
  "cta.social.title": "50 क्रेडिट्स मुफ्त में प्राप्त करें!",
  "cta.social.description":
    "सोशल मीडिया पर Youka के बारे में एक पोस्ट साझा करें, हमें टैग करें, और प्रत्येक प्लेटफ़ॉर्म के लिए 50 मुफ्त क्रेडिट्स अर्जित करें!",
  "cta.social.description.2":
    "Youka के Facebook पेज पर जाने के लिए क्लिक करें, इसे लाइक करें, एक पोस्ट साझा करें, और 50 मुफ्त क्रेडिट प्राप्त करने के लिए चैट में अपना ईमेल भेजें!",
  "Merge Line": "पंक्ति मर्ज करें",
  Player: "प्लेयर",
  "Key Step": "कुंजी चरण",
  "Tempo Step": "गति चरण",
  "Shift Line Forward": "पंक्ति आगे बढ़ाएं",
  "Shift Line Backward": "पंक्ति पीछे बढ़ाएं",
  "create.description":
    "ऑडियो या वीडियो फ़ाइलों (MP3, MP4 और अधिक) से कराओके बनाएं, या तुरंत सिंक्रनाइज़ लिरिक्स के साथ कराओके वीडियो बनाने के लिए एक URL पेस्ट करें।",
  "No file chosen": "कोई फ़ाइल नहीं चुनी गई",
  "Choose File": "फ़ाइल चुनें",
  "Watch Quick Start Video":
    "तुरंत सिंक्रनाइज़ लिरिक्स के साथ कराओके बनाने का वीडियो देखें",
  "Export Settings": "सेटिंग्स निर्यात करें",
  "Import Settings": "सेटिंग्स आयात करें",
  "Video Guides": "वीडियो गाइड्स",
  "Quick Start Guide": "तुरंत शुरू गाइड",
  "Lyrics Sync Guide": "लिरिक्स सिंक गाइड",
  Resolution: "रिज़ॉल्यूशन",
  "Subtitles Preset": "सबटाइटल प्रीसेट",
  Preset: "प्रीसेट",
  Done: "समाप्त",
  "New Style Mapping": "नया शैली मैपिंग",
  Horizontal: "क्षैतिज",
  Vertical: "ऊर्ध्वाधर",
  Square: "वर्ग",
  New: "नया",
  "New Subtitles Preset": "नया सबटाइटल प्रीसेट",
  "Change Aspect Ratio": "आस्पेक्ट अनुपात बदलें",
  "copyright.title.a": "मैं स्वीकार करता हूँ",
  "copyright.title.b": "संगीत उपयोग पुष्टि",
  "copyright.description":
    "इस बॉक्स को चेक करके, आप पुष्टि करते हैं कि (A) आपके पास इस वीडियो में शामिल सभी संगीत अधिकार हैं; या (B) संगीत सार्वजनिक डोमेन में है; या (C) आपके पास Youka प्लेटफ़ॉर्म पर संगीत का उपयोग करने के लिए सभी आवश्यक अधिकार धारकों से अनुमति है।",
  "Add Intro Video": "इंट्रो वीडियो जोड़ें",
  "dialogs.intro.description": "कराओके की शुरुआत में एक कस्टम वीडियो जोड़ें",
  Transition: "संक्रमण",
  Fade: "फीका",
  "Circle Open": "वृत्त खुला",
  "Circle Close": "वृत्त बंद",
  "Diagonal Open": "तिरछा खुला",
  "Diagonal Close": "तिरछा बंद",
  "Smooth Left": "स्मूथ बायाँ",
  "Smooth Right": "स्मूथ दायाँ",
  Squares: "वर्ग",
  Dissolve: "घुलना",
  Type: "प्रकार",
  "Song Title": "गाना का नाम",
  Artists: "कार्यकर्ताओं",
  Artist: "कार्यकर्ता",
  "Parse Titles": "गाना का नाम विश्लेषण करें",
  "sort.artist.asc": "कार्यकर्ता (A से Z)",
  "sort.artist.desc": "कार्यकर्ता (Z से A)",
  "Title Style": "गाना का नाम का स्टाइल",
  "Artist Style": "कार्यकर्ता का स्टाइल",
  "Analyse Library": "लाइब्रेरी विश्लेषण करें",
  "No Filter": "कोई फ़िल्टर नहीं",
  "credits.message_one": "यह {{count}} क्रेडिट का उपयोग करेगा",
  "credits.message_other": "यह {{count}} क्रेडिट का उपयोग करेगा",
  "credits.badge_one": "{{count}} क्रेडिट",
  "credits.badge_other": "{{count}} क्रेडिट",
  "Provide song lyrics to save credits": "गाने के लिए क्रेडिट बचाएं",
  "Upload to Cloud Library": "बाल को बाल में अपलोड करें",
  "Cloud Library": "बाल",
  "Open Cloud Library": "बाल खोलें",
};
